(function () {
  var form = document.querySelector('[data-type="add-to-cart-form"]');
  var dataEl = document.querySelector('[data-ground-variants]');
  var modal = document.getElementById('ground-1kg-confirm-modal');
  var cancelBtn = document.getElementById('ground-1kg-cancel');
  var confirmBtn = document.getElementById('ground-1kg-confirm');

  if (!form || !dataEl || !modal) return;

  var variants = JSON.parse(dataEl.textContent);
  var bypass = false;

  function getSelectedVariantId() {
    var input = form.querySelector('input.product-variant-id');
    return input ? parseInt(input.value, 10) : null;
  }

  function isRisky() {
    var id = getSelectedVariantId();
    if (!id) return false;
    var variant = variants.find(function (v) { return v.id === id; });
    if (!variant) return false;
    var opts = variant.options.map(function (o) { return o.toLowerCase().trim(); });
    var is1kg = opts.some(function (o) { return o === '1kg' || o === '1 kg'; });
    var isWhole = opts.some(function (o) { return o === 'whole bean' || o === 'em grão'; });
    return is1kg && !isWhole;
  }

  form.addEventListener('submit', function (e) {
    if (bypass) { bypass = false; return; }
    if (isRisky()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      modal.style.display = 'flex';
    }
  }, true);

  cancelBtn.addEventListener('click', function () {
    modal.style.display = 'none';
  });

  confirmBtn.addEventListener('click', function () {
    modal.style.display = 'none';
    bypass = true;
    form.requestSubmit ? form.requestSubmit() : form.submit();
  });
})();